import React from "react";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";

const BookingConditions = () => {
  return (
    <div className="bg-white">
      {/* header */}
      <Header className="static" />

      <div className="px-6 lg:px-32 xl:px-52 2xl:px-80 pt-32 lg:pt-48 pb-20 font-body">
        <h2 className="text-slate-900 text-2xl sm:text-3xl lg:text-4xl text-center pb-10 uppercase">
          Booking Conditions
        </h2>
        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900">
            CANCELLATION POLICY
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-3">
            FOR ALL BOOKINGS
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Free cancellation until 24 hours before scheduled pick
              time.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Cancellation would be 100% of the original price, if ride
              is cancelled within 24 hrs of scheduled pick time or in case of no
              show.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
            WAITING TIME
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
            AIRPORT ARRIVAL PICK-UP
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The first 60 minutes of waiting time from the time flight
              lands is free of charge, only if the User provides the airline and
              flight number that s/he will be arriving from. Else the free
              waiting will be calculted from the scheduled pick uptime. The
              Service Provider will check for changes to the scheduled arrival
              time and the agreed pickup time shall be updated to the flight's
              actual arrival time.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; After the first 60 minutes, additional waiting time will be
              charged in 5 minute blocks at 5 USD, plus applicable tax.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; If the User or passenger does not show up within sixty (60)
              minutes for after the agreed pickup time (or scheduled arrival
              time) at the agreed pickup location, and neither informs Drivado
              via telephone nor is contactable via the telephone number provided
              in the booking, the User is still obligated to pay the full price
              of the booking amount.
            </li>
          </ul>
        
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
            ONE-WAY BOOKING (OTHER THAN AIRPORT ARRIVAL PICK UP)
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The first 15 minutes of waiting time (beginning with
              scheduled pick-up time) are free of charge.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; After the first 15 minutes, additional waiting time will be
              charged in 5 minute blocks at 5 USD, plus applicable tax.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; If the User or passenger does not show up within fifteen
              (15) minutes for after the agreed pickup time at the agreed pickup
              location, and neither informs Drivado via telephone nor is
              contactable via the telephone number provided in the booking, the
              User is still obligated to pay the full price of the booking
              amount.
            </li>
          </ul>
        
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
            HOURLY BOOKING
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; For hourly bookings the Service Provider will remain at the
              agreed pick-up location until the hours booked have expired. To
              extend the time booked, the User or passenger must inform the
              Service Provider (see Extra Time below).
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; If the User or passenger does not show up at the agreed
              pickup time at the agreed pickup location without having cancelled
              the booking and the hours booked have expired, the User is
              obligated to pay the full price of the booking amount.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
            EXTRA TIME
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
            ONE-WAY BOOKING
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Any additional waiting time during the ride (e.g. requested
              stopover) shall be subject to surcharge as additional waiting
              time.
            </li>
          </ul>
        
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
            HOURLY BOOKING
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Hourly bookings include the hours that are stated on the
              booking form. It is only possible to add Extra Time in 1 hour
              blocks to the original booking. Each additional block of Extra
              Time is subject to surcharge and is calculated according to the
              original hourly rate of the booking.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
          EXTRA KILOMETERS
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          ONE-WAY BOOKING
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; One-way bookings include the kilometers that are necessary to get from the scheduled pick-up point to the booked destination. Each additional kilometer (e.g. detours for additional stops) is subject to prorated surcharge that is calculated by dividing the original booking price by the distance booked.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          HOURLY BOOKING
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Hourly bookings are associated with maximum kilometers included which are indicated at time of booking. Each additional kilometer is subject to prorated surcharge that is calculated by dividing the original booking price by the associated maximum kilometers included.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
          SPECIAL REQUESTS & ADDITIONAL SERVICES
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          GENERAL POLICY
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The provision of Additional Services (Extra Waiting Time, Extra Mileage, Extra Time) or Special Requests (e.g., excess/bulk luggage, language proficiency) cannot be guaranteed. Should the Service Provider accept the provision of such Additional Services/Special Requests, applicable fees may be amended to the Service Agreement and the invoice amount will be updated accordingly. Users are advised to check with Customer Support Team (support@drivado.com) prior to submitting a Special Request.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; If the User books a ride for another person, the User is still required to pay any Additional Services (e.g. extra time, additional stops) that the passenger requests from the Service Provider, assuming that the Service Provider accepts the provision of such Additional Services. If the User does not want to allow the booking of Additional Services, it is his/her obligation to communicate this to the passenger directly.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          DISTANT DROP-OFFS
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; For hourly bookings, drop off locations outside the city district of the pick-up location are subject to additional fees (e.g. Tolls, expenses for chauffeur making return trip).
            </li>
          </ul>
          
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          LUGGAGE AND ANIMALS
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; User must state as additional comment at time of booking for the transport of excess luggage, bulky luggage, or animals. Service Providers reserve the right to decline transportation service should such special accommodations not be part of the booking and the Service Provider cannot accommodate at time of pick-up.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          TRANSPORTATION OF CHILDREN
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Child safety regulations are not standardized worldwide, thus Service Providers in certain jurisdictions may be required to comply with more stringent local regulations.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; In general, Users are responsible for requesting safety seats for children by submitting additional comment specifying the number and age of children that will be transported as part of the booking. When in doubt, User should specify as part of the Booking Request in additional comments to ensure that the Service Provider will accommodate such request.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; For safety and legal compliance, Service Providers reserve the right to decline transportation service should such special accommodations not be part of the booking and the Service Provider cannot accommodate at time of pick-up.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
          RESPONSIBILITIES OF USERS AND PASSENGERS
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          PICK-UP AND DROP-OFF TIME
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Safety is of utmost importance. Drivers must drive according to road and traffic conditions and cannot guarantee drop-off times.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The User is responsible for booking a pick-up time in consideration of their desired drop-off time. We recommend using tools such as Google Maps for estimating approximate ride duration.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; For Airport drop-offs, we recommend following Airline guidelines to ensure you also allow sufficient time for check-in and boarding.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          PREVENTION OF CARRIAGE
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; If the User or passenger decides to refrain from carrying out a journey, because the Service Provider is unable to correctly transport the passengers, including children, animals and/or cannot transport extra or bulky luggage due to failure of the User to communicate transport requirements as stated above, the full amount of the agreed fees for the journey remains payable, less possible expenses saved.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The same applies if the User or passenger does not make the journey, because the Service Provider refrains from carrying out the transport service because the User or passenger requires special accommodations which the Service Provider did not previously agree to.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          BEHAVIOR IN THE VEHICLE
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp;  It is prohibited to smoke in the vehicle and the use of seat belts is mandatory.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp;  The vehicle is to be treated with care by the passengers.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; Unless the User explicitly requested as part of booking request, or the Service Provider additionally agrees, the Service Provider reserves the right to refuse the performance of the Service Agreement or end the journey if the User or passenger does not comply with these requirements or conducts disorderly despite a request by the Service Provider. Disorderly conduct includes, but is not limited to, vandalism, refusal to fasten seat belts, and activities that may make the Service Provider feel unsafe or uncomfortable. In such case the full amount of the agreed fees remains payable, less possible expenses saved. Furthermore, the Service Provider may claim compensation from the User or passenger of costs and expenses incurred for the necessary repair of damages to the vehicle or the cleaning of dirt in the vehicle exceeding the usual scope, which have been caused or inflicted by the passenger.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="font-body text-xl font-semibold text-slate-900 py-2">
          MISCELLANEOUS
          </h2>
          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          VEHICLE/BOOKING CLASS
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The limitations established for the agreed booking class apply respectively, particularly regarding the number of passengers to be transported and the volume of luggage in case of passenger transport services.
            </li>
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The vehicle images shown on the Platform strictly serve as illustrative examples of the class of vehicle that will be used – in particular, regional differences are possible.
            </li>
          </ul>

          <h2 className="font-body text-xl font-semibold text-slate-600 py-2">
          REFUSAL OF SERVICES FOR UNLAWFUL PURPOSES
          </h2>
          <ul className="font-body text-justify">
            <li className="font-body py-1">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-secondary"
              />
              &nbsp; The Service Provider may refuse the performance of the Service Agreement if s/he reasonably believes that the User or passenger(s) belongs to an unlawful organization, or uses the Services in an unlawful manner or for unlawful purposes.
            </li>
          </ul>
        </div>

      </div>

      {/* footer */}
      <Footer />
    </div>
  );
};

export default BookingConditions;
